import router from '../routes';

export default {
    apiVersion: 1,
    _call(requestType, url, data = {}, params = {}) {
        const statusCheck = new RegExp(/20(\d)/);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + window._store.getters['auth/token'];
        return new Promise((resolve, reject) => {
            let currentRoute = _.clone(window._router.currentRoute);
            axios[requestType]('/api/v' + this.apiVersion + '/' + url, data, {params})
                .then(response => {
                    if (!statusCheck.test(response.data.status)) {
                        return reject(response.data);
                    }
                    resolve(response.data);
                })
                .catch(({response}) => {
                    if (response.status === 401) {
                        window._store.commit('auth/rememberBackRoute', {
                            name: (currentRoute && currentRoute.name) ? currentRoute.name : 'tests_active'
                        });
                        window._store.commit('auth/logout');
                        window._store.commit('setIsLoading', false, {root: true});

                        return window._store.dispatch('auth/logoutSuccess');

                    }

                    if (response.status === 404) {
                        window._store.commit('setIsLoading', false, { root: true });

                        return router.push('/404');
                    }

                    if (response.data) {
                        response.data.status = response.status;
                    }

                    reject(response.data || response);
                });
        });
    },
    post(url, data = {}, query = {}) {
        return this._call('post', url, data, query);
    },
    get(url, query = {}) {
        return this._call('get', url, {params: query});
    },
    put(url, data = {}, query = {}) {
        return this._call('put', url, data, query);
    },
    delete(url, data = {}, query = {}) {
        return this._call('delete', url, {data: data}, query);
    },
}
